"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
const MoreVert_1 = __importDefault(require("@material-ui/icons/MoreVert"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const changeSidePanel_1 = require("../../actions/app/changeSidePanel");
const PopOverMenu_1 = __importDefault(require("../shared/PopOverMenu"));
const ThemeSelector_1 = __importDefault(require("./ThemeSelector"));
const logout_1 = __importDefault(require("../../actions/signin/logout"));
const Alert_1 = require("../../components/modals/Alert");
const panels_1 = require("../../domain/model/panels");
const constants_1 = require("../../constants");
exports.default = react_1.default.memo(UserMenu);
const useStyles = makeStyles_1.default((theme) => ({
    menuIcon: {
        color: colorManipulator_1.alpha(theme.colors.header.primaryTextColor, 0.6)
    }
}));
function UserMenu() {
    const dispatch = react_redux_1.useDispatch();
    const classes = useStyles();
    const [themeSelectorOpen, setThemeSelectorOpen] = react_1.useState(false);
    const menuItems = [];
    menuItems.push({ text: "New chat", action: () => dispatch(changeSidePanel_1.changeLeftPanel(panels_1.LeftPanelType.NewDirectChat)) });
    menuItems.push({ text: "New group", action: () => dispatch(changeSidePanel_1.changeLeftPanel(panels_1.LeftPanelType.NewGroupChat)) });
    menuItems.push({ text: "Join group", action: () => dispatch(changeSidePanel_1.changeLeftPanel(panels_1.LeftPanelType.JoinGroupChat)) });
    menuItems.push({ text: "Theme", action: () => setThemeSelectorOpen(true) });
    menuItems.push({ text: "Internet Identity", action: () => window.open(process.env.IDP_URL, "_blank") });
    menuItems.push({ text: "TEST MODE", action: () => Alert_1.alertDialog(constants_1.ABOUT_US) });
    menuItems.push({ text: "Logout", action: () => dispatch(logout_1.default()) });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PopOverMenu_1.default, { icon: react_1.default.createElement(MoreVert_1.default, { className: classes.menuIcon }), placement: "bottom-start", menuItems: menuItems }),
        themeSelectorOpen
            ? react_1.default.createElement(ThemeSelector_1.default, { onClose: () => setThemeSelectorOpen(false) })
            : null));
}
